<div class="file-search-sort" [class.with-tenant-search]="isSuperAdmin" [class.hide-sort-options]="!showSortOptions()">
  @if (isSuperAdmin && viewContext().isManagementView()) {
    <app-tenant-search (tenantSelected)="tenantSelected($event)"></app-tenant-search>
  }
  @if (showSortOptions()) {
    <div class="file-sort-options">
      <button
        mat-button
        [matMenuTriggerFor]="sortFieldOptions"
        [attr.aria-label]="'Files.Shared.SortFiles' | translate: locale.language">
        <span>{{ 'Files.Shared.SortBy' | translate: locale.language }}</span>
        <span>: {{ sortByFieldText() | translate: locale.language }}</span>
        <mat-icon matSuffix>sort</mat-icon>
      </button>
      <mat-menu #sortFieldOptions="matMenu">
        @for (option of sortOptions; track option.id) {
          <button
            mat-menu-item
            [disabled]="viewContext().sortField() === option.value"
            (click)="handleSortChange(option.value, 'asc')">
            @if (viewContext().sortField() === option.value) {
              <mat-icon>check</mat-icon>
            }
            <span>{{ option.label | translate: locale.language }}</span>
          </button>
        }
      </mat-menu>
      <button
        mat-icon-button
        (click)="handleSortChange(viewContext().sortField(), sortDirectionInfo.value)"
        [attr.aria-label]="sortDirectionInfo.label | translate: locale.language">
        <mat-icon>{{ sortDirectionInfo.icon }}</mat-icon>
      </button>
    </div>
  }
  <mat-form-field appearance="outline" class="file-search-field" floatLabel="always">
    <mat-label>{{ 'Files.Shared.SearchFiles' | translate: locale.language }}</mat-label>
    <input
      matInput
      type="text"
      [formControl]="fileSearch()"
      (keypress)="handleKeypressForSearch($event)"
      [attr.aria-label]="'Files.Shared.SearchFiles' | translate: locale.language" />
    <button
      mat-icon-button
      matSuffix
      [disabled]="searchSuffixBtn.disabled"
      (click)="searchSuffixBtn.action()"
      [attr.aria-label]="searchSuffixBtn.label | translate: locale.language">
      <mat-icon>{{ searchSuffixBtn.icon }}</mat-icon>
    </button>
  </mat-form-field>
</div>
